<template>
  <v-form ref="form" v-model="valid">
    <alert-error :error="error"></alert-error>
    <v-row no-gutters>
      <v-col v-for="option in options" cols="6">
        <v-switch
          v-model="localPersonOptions"
          color="primary"
          :label="option.translation.name"
          :value="option.id"
          dense
          hide-details
        ></v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <slot name="buttons" :valid="valid" />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'OptionForm',

  components: {
    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  model: {
    prop: 'personOptions'
  },

  props: {
    personOptions: {
      type: Array,
      required: true
    },
    options: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    valid: true,
    localPersonOptions: [],
    error: null
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }
  },

  watch: {
    localPersonOptions: {
      deep: true,
      handler: 'setPersonOptions'
    },
    personOptions: {
      deep: true,
      handler: 'setLocalPersonOptions'
    },
    options: {
      deep: true,
      handler: 'wtf'
    }
  },

  created() {},

  methods: {
    setPersonOptions(val) {
      this.$emit('input', Object.assign([], val));
    },
    wtf() {
      this.localPersonOptions = cloneDeep(this.personOptions);
    },
    setLocalPersonOptions() {
      if (
        JSON.stringify(this.localPersonOptions) === JSON.stringify(this.personOptions)
      ) {
        return;
      }
      this.localPersonOptions = cloneDeep(this.personOptions);
    }
  }
};
</script>
